// @flow

import Category from 'model/Category';
import university from 'data/products/university';

export default new Category('training', university);
